import React, { Component } from 'react';
import { ResourceService } from '../../services/resource.service';
import $ from 'jquery';
import CommonMessage from '../common/commonMessage';
import ReactTooltip from 'react-tooltip';
import Axios from 'axios';
import { axiosRequestWithAuth, API_HOST, axiosInstance } from './../../constants/server.constant';

export class BillingHistory extends Component {

    constructor(props) {
        super(props);

        this.state = {
            invTabActive: "summary",
            monthYear: "",
            instanceList: [],
            monthlyInstances: [],
            imageList: [],
            pagedImageList: [],
            volumeList: [],
            pagedVolumeList: [],
            bandwidthList: [],
            instanceTotal: 0,
            imageTotal: 0,
            volumeTotal: 0,
            bandwidthTotal: 0,
            allocatedBandwidth: "",
            usedBandwidth: "",
            usedPercentage: 0,
            isBandwidthResponseNull: 'false',
            currMonthYear: '',
            ccDetails: false,
            totalCost: 0,
            nextBillingDate: "",
            bandwidthResetDays: 0,
            message: '',
            showLoader: false,
            monthname: "",
            monthYearList: [],
            yearlyInstance: [],
            totalYearlyPrice: 0,
            yearlyVolumes: [],
            yearlyPagedVolumes: [],
            totalVolumesPrice: 0,
            ipFullList: [],
            pagedIpList: [],
            totalIpAmount: 0,
            lbFullList: [],
            pagedLbList: [],
            totalLbAmount: 0,
            isYearlyVol: false,
            indexCount: 0,
            yearlyPagedInstance: [],
            count: 50,
            monIndexCount: 0,
            imageIndexCount: 0,
            volIndexCount: 0,
            ipIndexCount: 0,
            yearlyVolIndexCount: 0,
            lbIndexCount: 0,
            prepaidMonthlyInsatnces: [],
            prepaidMonthlyPaged: [],
            prepaidMonthIndex: 0,
            totalMonthlyPrice: 0,
            isPrepaidMonthly: false,
            isYearly: true
        };
        this.getYearResources = this.getYearResources.bind(this);
        this.getResourceDetails = this.getResourceDetails.bind(this);
        this.getMonthNameAndYear = this.getMonthNameAndYear.bind(this);

    }

    componentDidMount() {
        var date = new Date();
        var month = date.getMonth() + 1;
        var year = date.getFullYear();
        if(month.toString().length == 1) {
            month = "0" + month;
        }
        var monthAndYear = month.toString() + year.toString();
        this.setState({
            monthYear: monthAndYear,
            monthname: this.getMonthNameAndYear(monthAndYear),
            monthYearList: this.getLast12Months(),
            currMonthYear: monthAndYear,
            bandwidthResetDays: this.numberOfDaysBandwidthReset(date)
        }, function () {
            this.getResourceDetails();
        });
        this.getYearResources();
        this.setNextBillingDate(date);
        this.getBandwidthData();
        //this.formatBytes()
        this.checkForSubscription();
    }

    numberOfDaysBandwidthReset(currDate) {
        var lastDate = new Date(currDate.getFullYear(), currDate.getMonth() + 1, 0);
        return Math.round(Math.abs((lastDate - currDate) / (24 * 3600 * 1000)));
    }

    formatBytes(bytes, decimals = 2) {
        if(bytes === 0) return '0 Bytes';

        const k = 1000;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

        const i = Math.floor(Math.log(bytes) / Math.log(k));

        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }


    getBandwidthData() {
        let userId = localStorage.getItem("userId");
        axiosInstance.get(API_HOST + "/resource/bandwidth/" + userId, axiosRequestWithAuth).then(resp => {
            let res = resp.data;
            // console.log(resp) ;
            if(res != null) {
                let inUseBandwidth = this.formatBytes(res.usedBandwidth);
                let maxBandwidth = this.formatBytes(res.allowedBandwidth);
                let usedPercantage = Math.round((res.usedBandwidth / res.allowedBandwidth) * 100);
                this.setState({
                    allocatedBandwidth: maxBandwidth,
                    usedBandwidth: inUseBandwidth,
                    usedPercentage: usedPercantage
                });
            }
            else {
                this.setState({ isBandwidthResponseNull: 'true' });
            }

        }).catch(error => {
            console.log("Error occured" + error);
        });
    }

    checkForSubscription = () => {
        ResourceService.getSubscriptionDetails().then(resp => {
            // console.log(resp)
            if(resp === false) {
                this.setState({
                    showLoader: false,
                    ccDetails: false
                });
                return;
            }
            if(resp.error) {
                this.setState({
                    showLoader: false,
                    ccDetails: false
                });
            } else {
                this.setState({
                    ccDetails: true,
                });
            }
        });
    };

    getFlavorDetails(flavorId) {
        try {
            let flavorList = JSON.parse(localStorage.getItem('flavorList'));
            let BmList = JSON.parse(localStorage.getItem('BMflavors'));
            if(flavorList !== null && flavorList !== undefined) {
                let flavorObj = undefined;
                try {
                    flavorObj = flavorList.find(item => item.flavour_id === flavorId);
                }
                catch(err) {
                    return '';
                }

                if(flavorObj === undefined) {
                    return '';
                }
                let nameArr = flavorObj.name.split(' ');
                let details = nameArr[1].toString().split('/');
                let type = 'Shared CPU';
                let processorType = 'vCPU, ';
                if(nameArr[0].includes('DCPU')) {
                    type = 'Dedicated CPU';
                    processorType = 'CPU, ';
                }
                let ram = details[0];
                let processor = flavorObj.vcpus;
                let storage = details[2];
                if(nameArr[0].includes('BM')) {

                    type = 'Bare Metal';

                    let bmObj = undefined;
                    try {
                        bmObj = BmList.find(item => item.id === flavorId);
                    }

                    catch(err) {
                        return '';
                    }

                    if(bmObj === undefined) {
                        return '';
                    }
                    processor = bmObj.processor + ", ";
                    processorType = bmObj.cpus + ', ';
                    ram = bmObj.ram;
                    storage = bmObj.storage;

                }
                //localStorage.setItem(flavorId, type + ', ' + processor + 'vCPU, ' + ram + ' RAM, ' + storage + ' NVMe storage')
                return type + ', ' + processor + processorType + ram + ' RAM, ' + storage + ' NVMe storage';
            }
        } catch(e) { }

        return '';
    }

    callYearResources = () => {
        $('#imageTable').hide();
        $('#volumeTable').hide();
        $('#bandwidthTable').hide();
        $(".section_table_rhs").hide();
        $("#ipTable").hide();
        $("#lbtable").hide();
        $(".filter_blk").hide();
        this.setState({
            isYearly: true, isPrepaidMonthly: false, indexCount: 0
        });
        this.getYearResources();

    };
    callPrepaidMonthlyResources = () => {
        $('#imageTable').hide();
        $('#volumeTable').hide();
        $('#bandwidthTable').hide();
        $(".section_table_rhs").hide();
        $("#ipTable").hide();
        $("#lbtable").hide();
        $(".filter_blk").hide();
        this.setState({
            isYearly: false, isPrepaidMonthly: true, prepaidMonthIndex: 0
        });
        this.getYearResources();

    };
    callMonthlyResources = () => {

        this.setState({
            isYearly: false,
            isPrepaidMonthly: false
        });
        let isYear = false;
        let isPrepaidMonthly = false;
        if(this.state.invTabActive === "instance") {
            if(isYear || isPrepaidMonthly) {
                $('#imageTable').hide();
                $('#volumeTable').hide();
                $('#bandwidthTable').hide();
                $(".section_table_rhs").hide();
                $("#ipTable").hide();
                $("#lbtable").hide();
                $(".filter_blk").hide();
            }
            else {
                $('#imageTable').hide();
                $('#volumeTable').hide();
                $('#bandwidthTable').hide();
                $("#ipTable").hide();
                $("#lbtable").hide();
                $(".section_table_rhs").show();
                $(".filter_blk").show();
            }

        }
        else {
            $('#imageTable').show();
            $('#volumeTable').show();
            $('#bandwidthTable').show();

            $("#ipTable").show();
            $("#lbtable").show();
            $(".section_table_rhs").show();
            $(".filter_blk").show();
        }

    };

    getYearResources = () => {
        this.setState({
            showLoader: true
        });
        ResourceService.getYearResourcesDetails().then(resp => {

            if(resp === false) {

                this.setState({
                    showLoader: false,
                    message: "Error while fetching yearly data"
                });
            }
            let yearlyInstances = [];
            let yearlyVolumes = [];
            let prepaidMonthlyInsatnces = [];

            let totalYearPrice = 0;
            let totalVolumesPrice = 0;
            let totalMonthlyPrice = 0;
            for(let i = 0; i < resp.length; i++) {
                if(resp[i].type === "instance") {
                    if(resp[i].payment_type === "Y") {
                        let d = new Date(resp[i].start_date);
                        let createdDate = d.toLocaleString('default', { month: 'short' }) + ' ' + d.getDate() + ',' + d.getFullYear() + ' ' + d.toLocaleString([], {
                            hour: '2-digit',
                            minute: '2-digit'
                        });
                        // let discprice = discnt.discount;
                        let flav = resp[i].flavour;
                        //let flaPrice = Number(flav.monthly_price)*12
                        //let afterDiscount = Number(flaPrice * (discprice/100))
                        totalYearPrice += Number(resp[i].amount);
                        let flavId = flav.flavour_id;
                        yearlyInstances.push({
                            id: resp[i].id,
                            name: resp[i].name,
                            instance: resp[i].resource_id,
                            created: createdDate,
                            price: Number(resp[i].amount),
                            sysConfig: this.getFlavorDetails(flavId)
                        });
                    }
                    else {
                        let d = new Date(resp[i].start_date);
                        let createdDate = d.toLocaleString('default', { month: 'short' }) + ' ' + d.getDate() + ',' + d.getFullYear() + ' ' + d.toLocaleString([], {
                            hour: '2-digit',
                            minute: '2-digit'
                        });
                        // let discprice = discnt.discount;
                        let flav = resp[i].flavour;
                        //let flaPrice = Number(flav.monthly_price)*12
                        //let afterDiscount = Number(flaPrice * (discprice/100))
                        totalMonthlyPrice += Number(resp[i].amount);
                        let flavId = flav.flavour_id;
                        prepaidMonthlyInsatnces.push({
                            id: resp[i].id,
                            name: resp[i].name,
                            instance: resp[i].resource_id,
                            created: createdDate,
                            price: Number(resp[i].amount),
                            sysConfig: this.getFlavorDetails(flavId)
                        });
                    }

                }
                else {
                    let d = new Date(resp[i].start_date);
                    let createdDate = d.toLocaleString('default', { month: 'short' }) + ' ' + d.getDate() + ',' + d.getFullYear() + ' ' + d.toLocaleString([], {
                        hour: '2-digit',
                        minute: '2-digit'
                    });

                    totalVolumesPrice += Number(resp[i].amount);
                    yearlyVolumes.push({
                        id: resp[i].id,
                        name: resp[i].name,
                        volId: resp[i].resource_id,
                        size: resp[i].size,
                        created: createdDate,
                        price: Number(resp[i].amount)

                    });
                }
                //let discnt = resp[i].discount;

            }
            //yearlyInstances = [{ name: 1 }, { name: 2 }, { name: 3 }];

            yearlyInstances.sort(function (a, b) {
                return new Date(b.created) - new Date(a.created);
            });
            yearlyVolumes.sort(function (a, b) {
                return new Date(b.created) - new Date(a.created);
            });
            prepaidMonthlyInsatnces.sort(function (a, b) {
                return new Date(b.created) - new Date(a.created);
            });

            let yearlyPagedInstance = [...yearlyInstances];
            if(yearlyInstances.length > this.state.count) {
                yearlyPagedInstance = yearlyPagedInstance.slice(0, this.state.count);
            }

            let yearlyPagedVolumes = [...yearlyVolumes];
            if(yearlyVolumes.length > this.state.count) {
                yearlyPagedVolumes = yearlyPagedVolumes.slice(0, this.state.count);
            }

            let prepaidMonthlyPaged = [...prepaidMonthlyInsatnces];
            if(prepaidMonthlyInsatnces.length > this.state.count) {
                prepaidMonthlyPaged = prepaidMonthlyPaged.slice(0, this.state.count);
            }

            this.setState({
                showLoader: false,
                yearlyInstance: yearlyInstances,
                totalYearlyPrice: totalYearPrice,
                yearlyVolumes: yearlyVolumes,
                totalVolumesPrice: totalVolumesPrice,
                yearlyPagedInstance: yearlyPagedInstance,
                yearlyPagedVolumes: yearlyPagedVolumes,
                prepaidMonthlyInsatnces: prepaidMonthlyInsatnces,
                prepaidMonthlyPaged: prepaidMonthlyPaged,
                totalMonthlyPrice: totalMonthlyPrice

            });

        }).catch(error => {
            console.log(error);
            this.setState({
                showLoader: false,
                message: "Error while fetching yearly data"
            });
        });

    };
    logout() {
        let userId = localStorage.getItem("userId");
        localStorage.clear();
        sessionStorage.clear();
        window.location.href = API_HOST + "/login/logout?userId=" + userId;
    }

    setNextBillingDate(date) {
        if(date.getMonth() == 11) {
            var current = new Date(date.getFullYear() + 1, 0, 1);
            this.setState({
                nextBillingDate: this.formateDate(current)
            });
        } else {
            var current = new Date(date.getFullYear(), date.getMonth() + 1, 1);
            this.setState({
                nextBillingDate: this.formateDate(current)
            });
        }
    }

    formateDate(current) {
        var dd = current.getDate();
        var mm = current.getMonth() + 1;
        var yyyy = current.getFullYear();
        if(dd < 10) {
            dd = '0' + dd;
        }

        if(mm < 10) {
            mm = '0' + mm;
        }
        current = mm + '-' + dd + '-' + yyyy;
        return current;
    }

    handleMonthYearChange = (event) => {
        this.setState({ monthYear: event.target.value }, function () {

        });
    };

    getResourceDetails = () => {
        this.setState({
            showLoader: true,
            isYearly: false,
            isPrepaidMonthly: false
        });
        ResourceService.getResourceDetails(this.state.monthYear).then(data => {
            this.setState({
                showLoader: false
            });
            let totalcost = 0;
            //console.log(data);
            if(data && data !== "") {
                for(let i = 0; i < data.length; i++) {
                    data[i].amount = Number((+data[i].amount).toFixed(2));
                    data[i].flavour = data[i].flavour == null ? "" : data[i].flavour;
                }
                let iL = data.filter(data => data.type.toUpperCase() === "INSTANCE");
                let iML = data.filter(data => data.type.toUpperCase() === "IMAGE");
                let vL = data.filter(data => data.type.toUpperCase() === "VOLUME");
                let bL = data.filter(data => data.type.toUpperCase() === "INSTANCE_NETWORK_INTERFACE");
                let ipList = data.filter(data => data.type.toUpperCase() === "IP");
                let lbList = data.filter(data => data.type.toUpperCase() === "LB");

                let iLTotal = this.findTotalAmount(iL);
                let iMLTotal = this.findTotalAmount(iML);
                let vLTotal = this.findTotalAmount(vL);
                let bLTotal = this.findTotalAmount(bL);
                let ipTotal = this.findTotalAmount(ipList);
                let lbTotal = this.findTotalAmount(lbList);
                //let totalcost =  Number((iLTotal).toFixed(2))+Number((iMLTotal).toFixed(2))+Number((vLTotal).toFixed(2))+Number((bLTotal).toFixed(2));
                //console.log(Math.round((iLTotal + Number.EPSILON) * 100) / 100);
                totalcost = iLTotal + iMLTotal + vLTotal + bLTotal + ipTotal + lbTotal;
                totalcost = Math.round((totalcost + Number.EPSILON) * 100) / 100;

                var monthlyInstances = [...iL];
                if(iL.length > this.state.count) monthlyInstances = monthlyInstances.slice(0, this.state.count);

                var pagedImageList = [...iML];
                if(iML.length > this.state.count) pagedImageList = pagedImageList.slice(0, this.state.count);

                var pagedVolumeList = [...vL];
                if(vL.length > this.state.count) pagedVolumeList = pagedVolumeList.slice(0, this.state.count);

                var pagedIpList = [...ipList];
                if(ipList.length > this.state.count) pagedIpList = pagedIpList.slice(0, this.state.count);

                var pagedLbList = [...lbList];
                if(lbList.length > this.state.count) pagedLbList = pagedLbList.slice(0, this.state.count);


                this.setState({
                    instanceList: iL,
                    imageList: iML,
                    volumeList: vL,
                    bandwidthList: bL,
                    ipFullList: ipList,
                    pagedIpList: pagedIpList,
                    lbFullList: lbList,
                    pagedLbList: pagedLbList,
                    instanceTotal: Number((iLTotal).toFixed(2)) == 0 ? "0.0" : Number((iLTotal).toFixed(2)),
                    imageTotal: Number((iMLTotal).toFixed(2)) == 0 ? "0.0" : Number((iMLTotal).toFixed(2)),
                    volumeTotal: Number((vLTotal).toFixed(2)) == 0 ? "0.0" : Number((vLTotal).toFixed(2)),
                    bandwidthTotal: Number((bLTotal).toFixed(2)) == 0 ? "0.0" : Number((bLTotal).toFixed(2)),
                    totalIpAmount: Number((ipTotal).toFixed(2)) == 0 ? "0.0" : Number((ipTotal).toFixed(2)),
                    totalLbAmount: Number((lbTotal).toFixed(2)) == 0 ? "0.0" : Number((lbTotal).toFixed(2)),
                    totalCost: totalcost == 0 ? "0.0" : totalcost,
                    monthlyInstances: monthlyInstances,
                    pagedImageList: pagedImageList,
                    pagedVolumeList: pagedVolumeList
                });

                this.setState({
                    monthname: this.getMonthNameAndYear(this.state.monthYear),
                });

            } else {
                this.setState({
                    instanceList: [],
                    monthlyInstances: [],
                    imageList: [],
                    volumeList: [],
                    pagedVolumeList: [],
                    bandwidthList: [],
                    ipFullList: [],
                    pagedIpList: [],
                    lbFullList: [],
                    pagedLbList: [],
                    instanceTotal: "0.0",
                    imageTotal: "0.0",
                    volumeTotal: "0.0",
                    bandwidthTotal: "0.0",
                    totalIpAmount: "0.0",
                    totalLbAmount: "0.0",
                    totalCost: "0.0",
                    pagedImageList: []
                });
            }

        }).catch(err => {
            console.log("Error occured : " + err);
        });
    };


    findTotalAmount(list) {
        let sum = 0;
        for(let i = 0; i < list.length; i++) {
            sum = sum + list[i].amount;
        }
        return sum;
    }

    handleResource(type) {
        window.scrollTo({ top: 0 });
        this.setState({
            invTabActive: type
        });
        if(type == "summary") {

            this.setState({
                isYearly: false,
                isYearlyVol: false,
                isPrepaidMonthly: false
            }, () => {
                if(this.state.isYearly || this.state.isPrepaidMonthly) {
                    $('#instanceTable').show();
                    $('#imageTable').hide();
                    $('#volumeTable').hide();
                    $('#bandwidthTable').hide();
                    $("#ipTable").hide();
                    $("#lbtable").hide();
                    $(".section_table_rhs").hide();
                    $(".filter_blk").hide();
                }
                else {
                    $('#instanceTable').show();
                    $('#imageTable').show();
                    $('#volumeTable').show();
                    $('#bandwidthTable').show();
                    $("#ipTable").show();
                    $("#lbtable").show();//prodHide
                    $(".section_table_rhs").show();
                    $(".filter_blk").show();
                }
            });



        } else if(type == "instance") {
            this.setState({
                isYearly: false,
                isPrepaidMonthly: false
            }, () => {
                if(this.state.isYearly || this.state.isPrepaidMonthly) {
                    $('#instanceTable').show();
                    $('#imageTable').hide();
                    $('#volumeTable').hide();
                    $('#bandwidthTable').hide();
                    $("#ipTable").hide();
                    $("#lbtable").hide();
                    $(".section_table_rhs").hide();
                    $(".filter_blk").hide();
                }
                else {
                    $('#instanceTable').show();
                    $('#imageTable').hide();
                    $('#volumeTable').hide();
                    $('#bandwidthTable').hide();
                    $("#ipTable").hide();
                    $("#lbtable").hide();
                    $(".section_table_rhs").show();
                    $(".filter_blk").show();
                }
            });




        } else if(type == "image") {
            $('#instanceTable').hide();
            $('#imageTable').show();
            $('#volumeTable').hide();
            $('#bandwidthTable').hide();
            $("#ipTable").hide();
            $("#lbtable").hide();
            $(".section_table_rhs").show();
            $(".filter_blk").show();
        } else if(type == "volume") {
            $('#instanceTable').hide();
            $('#imageTable').hide();
            $('#volumeTable').show();
            $('#bandwidthTable').hide();
            $("#ipTable").hide();
            $("#lbtable").hide();
            $(".section_table_rhs").show();
            $(".filter_blk").show();
            this.setState({
                isYearlyVol: false
            });
        } else if(type == "ipbill") {
            $('#instanceTable').hide();
            $('#imageTable').hide();
            $('#volumeTable').hide();
            $('#bandwidthTable').hide();
            $("#ipTable").show();
            $("#lbtable").hide();
            $(".section_table_rhs").show();
            $(".filter_blk").show();
        }
        else if(type == "lbbill") {
            $('#instanceTable').hide();
            $('#imageTable').hide();
            $('#volumeTable').hide();
            $('#bandwidthTable').hide();
            $("#ipTable").hide();
            $("#lbtable").show();//prodHide
            $(".section_table_rhs").show();
            $(".filter_blk").show();
        }
        else {
            $('#instanceTable').hide();
            $('#imageTable').hide();
            $('#volumeTable').hide();
            $('#bandwidthTable').show();
            $("#ipTable").hide();
            $("#lbtable").hide();
            $(".section_table_rhs").show();
            $(".filter_blk").show();
        }
    }


    getLast12Months() {
        var m = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        var monthYearList = [];
        var d = new Date();
        d.setDate(1);
        for(var i = 0; i < 12; i++) {
            var monthname = m[d.getMonth()];
            var year = d.getFullYear().toString();
            var lebelVal = monthname + ' ' + year;
            d.setMonth(d.getMonth() - 1);
            var monthNo = "";
            switch(monthname) {
                case "January": monthNo = "01";
                    break;
                case "February": monthNo = "02";
                    break;
                case "March": monthNo = "03";
                    break;
                case "April": monthNo = "04";
                    break;
                case "May": monthNo = "05";
                    break;
                case "June": monthNo = "06";
                    break;
                case "July": monthNo = "07";
                    break;
                case "August": monthNo = "08";
                    break;
                case "September": monthNo = "09";
                    break;
                case "October": monthNo = "10";
                    break;
                case "November": monthNo = "11";
                    break;
                case "December": monthNo = "12";
                    break;
                default:
                    break;
            }
            monthYearList.push({ "value": monthNo + "" + year, "lebel": lebelVal });

        }
        //console.log(monthYearList)
        return monthYearList;
    }

    getMonthNameAndYear(monthAndYear) {
        var month = monthAndYear.substring(0, 2);
        // console.log(month) ;
        var monthNameAndYear = "";
        switch(month) {
            case "01": monthNameAndYear = "Janaury";
                break;
            case "02": monthNameAndYear = "February";
                break;
            case "03": monthNameAndYear = "March";
                break;
            case "04": monthNameAndYear = "April";
                break;
            case "05": monthNameAndYear = "May";
                break;
            case "06": monthNameAndYear = "June";
                break;
            case "07": monthNameAndYear = "July";
                break;
            case "08": monthNameAndYear = "August";
                break;
            case "09": monthNameAndYear = "September";
                break;
            case "10": monthNameAndYear = "October";
                break;
            case "11": monthNameAndYear = "November";
                break;
            case "12": monthNameAndYear = "December";
                break;
            default:
                break;
        }

        monthNameAndYear = monthNameAndYear + " " + monthAndYear.substring(2);
        return monthNameAndYear;
    }

    calVolumeOperation = (param) => {
        if(param === "monthly") {
            $(".filter_blk").show();
            $(".section_table_rhs").show();
            this.setState({
                isYearlyVol: false
            });

        }
        else {
            $(".filter_blk").hide();
            if(this.state.invTabActive === "volume")
                $(".section_table_rhs").hide();
            this.setState({
                isYearlyVol: true
            });
            this.getYearResources();
        }
    };
    handlePreviousClick = (event) => {
        if(this.state.indexCount === 0) {
            this.setState({
                message: "Reached start of list, press next to display the rest",
            });
            return;
        } else {
            let yearlyInstance = [...this.state.yearlyInstance];
            let indexCount = this.state.indexCount - this.state.count;
            this.setState({
                indexCount: this.state.indexCount - this.state.count,
                yearlyPagedInstance: yearlyInstance.slice(indexCount, this.state.indexCount)
            });
            return;
        }
        event.preventDefault();
    };

    handleNextClick = (event) => {
        event.preventDefault();
        if(this.state.indexCount + this.state.count > this.state.yearlyInstance.length - 1) {
            this.setState({
                message: "Reached end of list, no more instances to show"
            });
            return;
        } else {
            let yearlyInstance = [...this.state.yearlyInstance];
            let indexCount = this.state.indexCount + this.state.count;
            let endCount = indexCount + this.state.count;
            if(endCount > yearlyInstance.length) endCount = yearlyInstance.length;
            this.setState({
                indexCount: indexCount,
                yearlyPagedInstance: yearlyInstance.slice(indexCount, endCount)
            });
        }
    };
    handlePrepaidPreviousClick = (event) => {
        if(this.state.prepaidMonthIndex === 0) {
            this.setState({
                message: "Reached start of list, press next to display the rest",
            });
            return;
        } else {
            let prepaidMonthlyInsatnces = [...this.state.prepaidMonthlyInsatnces];
            let prepaidMonthIndex = this.state.prepaidMonthIndex - this.state.count;
            this.setState({
                prepaidMonthIndex: this.state.prepaidMonthIndex - this.state.count,
                yearlyPagedInstance: prepaidMonthlyInsatnces.slice(prepaidMonthIndex, this.state.prepaidMonthIndex)
            });
            return;
        }
        event.preventDefault();
    };

    handlePrepaidNextClick = (event) => {
        event.preventDefault();
        if(this.state.prepaidMonthIndex + this.state.count > this.state.prepaidMonthlyInsatnces.length - 1) {
            this.setState({
                message: "Reached end of list, no more instances to show"
            });
            return;
        } else {
            let prepaidMonthlyInsatnces = [...this.state.prepaidMonthlyInsatnces];
            let prepaidMonthIndex = this.state.prepaidMonthIndex + this.state.count;
            let endCount = prepaidMonthIndex + this.state.count;
            if(endCount > prepaidMonthlyInsatnces.length) endCount = prepaidMonthlyInsatnces.length;
            this.setState({
                prepaidMonthIndex: prepaidMonthIndex,
                yearlyPagedInstance: prepaidMonthlyInsatnces.slice(prepaidMonthIndex, endCount)
            });
        }
    };


    handleNextInstClick = (event) => {
        let instanceList = [...this.state.instanceList];
        let indexCount = this.state.monIndexCount + this.state.count;
        let endCount = indexCount + this.state.count;
        if(endCount > instanceList.length) endCount = instanceList.length;
        this.setState({
            monIndexCount: indexCount,
            monthlyInstances: instanceList.slice(indexCount, endCount)
        });
        event.preventDefault();
    };

    handlePreviousInstClick = (event) => {
        let instanceList = [...this.state.instanceList];
        let monIndexCount = this.state.monIndexCount - this.state.count;
        this.setState({
            monIndexCount: this.state.monIndexCount - this.state.count,
            monthlyInstances: instanceList.slice(monIndexCount, this.state.monIndexCount)
        });
        event.preventDefault();
    };

    handleNextImagesClick = (event) => {
        let imageList = [...this.state.imageList];
        let indexCount = this.state.imageIndexCount + this.state.count;
        let endCount = indexCount + this.state.count;
        if(endCount > imageList.length) endCount = imageList.length;
        this.setState({
            imageIndexCount: indexCount,
            pagedImageList: imageList.slice(indexCount, endCount)
        });
        event.preventDefault();
    };

    handlePreviousImagesClick = (event) => {
        let imageList = [...this.state.imageList];
        let imageIndexCount = this.state.imageIndexCount - this.state.count;
        this.setState({
            imageIndexCount: this.state.imageIndexCount - this.state.count,
            pagedImageList: imageList.slice(imageIndexCount, this.state.imageIndexCount)
        });
        event.preventDefault();
    };

    handleNextVolumeClick = (event) => {
        let volumeList = [...this.state.volumeList];
        let volIndexCount = this.state.volIndexCount + this.state.count;
        let endCount = volIndexCount + this.state.count;
        if(endCount > volumeList.length) endCount = volumeList.length;
        this.setState({
            volIndexCount: volIndexCount,
            pagedVolumeList: volumeList.slice(volIndexCount, endCount)
        });
        event.preventDefault();
    };

    handlePreviousVolumeClick = (event) => {
        let volumeList = [...this.state.volumeList];
        let volIndexCount = this.state.volIndexCount - this.state.count;
        this.setState({
            volIndexCount: this.state.volIndexCount - this.state.count,
            pagedVolumeList: volumeList.slice(volIndexCount, this.state.volIndexCount)
        });
        event.preventDefault();
    };

    handleNextIpClick = (event) => {
        let ipFullList = [...this.state.ipFullList];
        let ipIndexCount = this.state.ipIndexCount + this.state.count;
        let endCount = ipIndexCount + this.state.count;
        if(endCount > ipFullList.length) endCount = ipFullList.length;
        this.setState({
            ipIndexCount: ipIndexCount,
            pagedIpList: ipFullList.slice(ipIndexCount, endCount)
        });
        event.preventDefault();
    };

    handlePreviousIpClick = (event) => {
        let ipFullList = [...this.state.ipFullList];
        let ipIndexCount = this.state.ipIndexCount - this.state.count;
        this.setState({
            ipIndexCount: this.state.ipIndexCount - this.state.count,
            pagedIpList: ipFullList.slice(ipIndexCount, this.state.ipIndexCount)
        });
        event.preventDefault();
    };
    handleNextLbClick = (event) => {
        let lbFullList = [...this.state.lbFullList];
        let lbIndexCount = this.state.lbIndexCount + this.state.count;
        let endCount = lbIndexCount + this.state.count;
        if(endCount > lbFullList.length) endCount = lbFullList.length;
        this.setState({
            lbIndexCount: lbIndexCount,
            pagedLbList: lbFullList.slice(lbIndexCount, endCount)
        });
        event.preventDefault();
    };

    handlePreviousLbClick = (event) => {
        let lbFullList = [...this.state.lbFullList];
        let lbIndexCount = this.state.lbIndexCount - this.state.count;
        this.setState({
            lbIndexCount: this.state.lbIndexCount - this.state.count,
            pagedLbList: lbFullList.slice(lbIndexCount, this.state.lbIndexCount)
        });
        event.preventDefault();
    };

    handleNextYearlyVolClick = (event) => {
        let yearlyVolumes = [...this.state.yearlyVolumes];
        let yearlyVolIndexCount = this.state.yearlyVolIndexCount + this.state.count;
        let endCount = yearlyVolIndexCount + this.state.count;
        if(endCount > yearlyVolumes.length) endCount = yearlyVolumes.length;
        this.setState({
            yearlyVolIndexCount: yearlyVolIndexCount,
            yearlyPagedVolumes: yearlyVolumes.slice(yearlyVolIndexCount, endCount)
        });
        event.preventDefault();
    };

    handlePreviousYearlyVolClick = (event) => {
        let yearlyVolumes = [...this.state.yearlyVolumes];
        let yearlyVolIndexCount = this.state.yearlyVolIndexCount - this.state.count;
        this.setState({
            yearlyVolIndexCount: this.state.yearlyVolIndexCount - this.state.count,
            yearlyPagedVolumes: yearlyVolumes.slice(yearlyVolIndexCount, this.state.yearlyVolIndexCount)
        });
        event.preventDefault();
    };

    render() {
        var role = 4;
        if(role == 1) {
            this.logout(); //if subuser tries to access just logout
            return null;
        }

        let baseClassForBandwidthColor = "percent_progress ";
        let fullClassForBandwidthColor = baseClassForBandwidthColor;
        let bandwidthPercentage = this.state.usedPercentage;
        let customBandwidthPercent = bandwidthPercentage + '%';
        if(bandwidthPercentage >= 90 && bandwidthPercentage < 100) {
            fullClassForBandwidthColor += "ninety";
        }
        if(bandwidthPercentage >= 100) {
            fullClassForBandwidthColor += "full";
            customBandwidthPercent = 100 + '%';
        }



        return (
            <React.Fragment>
                <div className="full_page_loader" style={ { display: this.state.showLoader ? 'block' : 'none' } }>
                    <div className="loader_icon"></div>
                </div>
                <section className="accountModule_wrapper prepaid_billing billing_history_sec ">
                    <div className="accModule_head_wrap" style={ { display: "none" } }>
                        <div className="settModule_head_lhs">
                            <h2>Billing History</h2>
                            <p className="head_info">View all the billing transactions for your account</p>
                        </div>
                    </div>
                    <div className="field_sec_wrap clearfix">
                        <div className="bilHistory_tab_wrap">
                            <div className="custom_tabs_wrap">
                                <ul>
                                    <li className={ "bill_summary_tab " + (this.state.invTabActive === "summary" ? "active " : "") } onClick={ () => this.handleResource("summary") } >Summary</li>
                                    <li className={ "bill_instance_tab " + (this.state.invTabActive === "instance" ? "active " : "") } onClick={ () => this.handleResource("instance") } >Instances </li>
                                    <li className={ "bill_image_tab " + (this.state.invTabActive === "image" ? "active " : "") } onClick={ () => this.handleResource("image") } >Images</li>
                                    <li className={ "bill_volume_tab " + (this.state.invTabActive === "volume" ? "active " : "") } onClick={ () => this.handleResource("volume") }>Volumes</li>
                                    <li className={ "bill_bandwidth_tab " + (this.state.invTabActive === "bandwidth" ? "active " : "") } onClick={ () => this.handleResource("bandwidth") }>Bandwidth Usage</li>
                                    <li className={ "bill_floatingIP_tab " + (this.state.invTabActive === "ipbill" ? "active " : "") } onClick={ () => this.handleResource("ipbill") }>Additional IPs</li>
                                    <li className={ "bill_lb_tab " + (this.state.invTabActive === "lbbill" ? "active " : "") } onClick={ () => this.handleResource("lbbill") }>Load Balancers</li>
                                </ul>
                            </div>
                        </div>
                        <div className="billHistory_date_filter" style={ { display: "none" } }>
                            <div className="cal_dd">
                                <div className="cal_dd_inner d_flex">
                                    <div className="calendar">
                                        <div className="calendar_inner">
                                            <div className="calendar_item_wrap" style={ { display: 'none' } }>
                                                <div className="calendar_item">
                                                    <p>From Date</p>
                                                    <div className="input_text_wrap">
                                                        <input type="text" id="datepicker_start_instance" className="input_text" placeholder="From Date" />
                                                        <span className="icon"></span>
                                                    </div>
                                                </div>
                                                <div className="calendar_item">
                                                    <p>End Date</p>
                                                    <div className="input_text_wrap">
                                                        <input type="text" id="datepicker_end_instance" className="input_text" placeholder="End Date" />
                                                        <span className="icon"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="common_txtBox_row" style={ { display: "none" } }>
                                                <div className="selctBox_container">
                                                    <div className="custom_select_box">
                                                        <select name="monthYear" value={ this.state.monthYear } onChange={ this.handleMonthYearChange } >
                                                            { this.state.monthYearList.map(my => (
                                                                <option value={ my.value }>{ my.lebel }</option>
                                                            )) }
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="calendar_btn_wrap">
                                                <input type="button" name="" value="Generate" onClick={ this.getResourceDetails } className="common_cta_btn blue" />
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div className="options_wrap">
                                        <div className="cta_wrap">
                                            <div className="pdf_download">
                                                <span className="svg_wrap">
                                                    <svg x="0px" y="0px" viewBox="0 0 512 512" enableBackground="new 0 0 512 512" xmlSpace="preserve">
                                                        <g>
                                                            <g>
                                                                <g>
                                                                    <path fill="#F24C4C" d="M393.7,149.4l-77.8-77.8c-1.5-1.5-3.4-2.3-5.5-2.3H147.1c-17.2,0-31.1,14-31.1,31.1v311.1     c0,17.2,14,31.1,31.1,31.1h217.8c17.2,0,31.1-14,31.1-31.1V154.9C396,152.8,395.2,1this.state.count.8,393.7,149.4z M318.2,95.9l51.2,51.2     h-35.7c-8.6,0-15.6-7-15.6-15.6V95.9z M380.4,411.6c0,8.6-7,15.6-15.6,15.6H147.1c-8.6,0-15.6-7-15.6-15.6V100.4     c0-8.6,7-15.6,15.6-15.6h155.6v46.7c0,17.2,14,31.1,31.1,31.1h46.7V411.6z"></path>
                                                                    <path fill="#F24C4C" d="M295.7,297.7c-7.2-5.7-14-11.5-18.6-16c-5.9-5.9-11.2-11.7-15.8-17.1c7.2-22.1,10.3-33.5,10.3-39.6     c0-25.8-9.3-31.1-23.3-31.1c-10.6,0-23.3,5.5-23.3,31.9c0,11.6,6.4,25.7,19,42.1c-3.1,9.4-6.7,20.3-10.8,32.5     c-2,5.9-4.1,11.3-6.3,16.3c-1.8,0.8-3.6,1.6-5.3,2.5c-6.2,3.1-12.1,5.9-17.5,8.5c-24.8,11.8-41.2,19.5-41.2,34.9     c0,11.2,12.1,18.1,23.3,18.1c14.5,0,36.3-19.3,52.2-51.9c16.6-6.5,37.1-11.4,53.4-14.4c13,10,27.4,19.6,34.4,19.6     c19.3,0,23.3-11.2,23.3-20.5c0-18.4-21-18.4-31.1-18.4C315.1,294.9,306.7,295.8,295.7,297.7z M186,364.9c-4.4,0-7.5-2.1-7.8-2.5     c0-5.5,16.4-13.3,32.3-20.8c1-0.5,2-1,3.1-1.5C202,357,190.4,364.9,186,364.9z M240.4,225.6c0-16.3,5.1-16.3,7.8-16.3     c5.5,0,7.8,0,7.8,15.6c0,3.3-2.2,11.5-6.2,24.3C243.7,239.8,240.4,231.7,240.4,225.6z M246.4,309.2c0.5-1.4,1-2.7,1.4-4.1     c2.9-8.7,5.5-16.4,7.8-23.4c3.2,3.6,6.7,7.2,10.4,10.9c1.5,1.5,5.1,4.7,9.9,8.8C266.4,303.5,256.2,306.1,246.4,309.2z      M333.8,313.3c0,3.5,0,4.9-7.2,5c-2.1-0.5-7-3.3-13.1-7.5c2.2-0.2,3.8-0.4,4.7-0.4C329.7,310.4,333,311.6,333.8,313.3z"></path>
                                                                </g>
                                                            </g>
                                                        </g>
                                                    </svg>
                                                </span>Download PDF
                                            </div>
                                            <div className="send_email">
                                                <span className="svg_wrap">
                                                    <svg x="0px" y="0px" viewBox="0 0 512 512" enableBackground="new 0 0 512 512" xmlSpace="preserve">
                                                        <g>
                                                            <g>
                                                                <path fill="#378EC3" d="M432.4,109.4H79.6C58.9,109.4,42,126.3,42,147v218c0,20.7,16.9,37.6,37.6,37.6h352.8    c20.7,0,37.6-16.9,37.6-37.6V147C470,126.3,453.1,109.4,432.4,109.4z M427.5,134.5l-5,4.2L270.9,264.8c-8.6,7.2-21.2,7.2-29.8,0    L89.5,138.6l-5-4.2H427.5z M67.1,152.6l123.5,102.8L67.1,337.5V152.6z M432.4,377.5H79.6c-6.1,0-11.1-4.3-12.3-10l143.3-95.4    l14.4,12c9,7.5,20,11.2,31,11.2c11,0,22-3.7,31-11.2l14.4-12l143.3,95.4C443.5,373.2,438.4,377.5,432.4,377.5z M444.9,337.5    l-123.5-82.2l123.5-102.8V337.5z"></path>
                                                            </g>
                                                        </g>
                                                    </svg>
                                                </span>Send an email
                                            </div>
                                        </div>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                        <div className="section_table_wrap">
                            <div className="section_table_lhs">
                                <div className="filter_blk">
                                    <div className="common_txtBox_row">
                                        <div className="selctBox_container">
                                            <div className="custom_select_box">
                                                <select name="monthYear" value={ this.state.monthYear } onChange={ this.handleMonthYearChange } >
                                                    { this.state.monthYearList.map(my => (
                                                        <option value={ my.value }>{ my.lebel }</option>
                                                    )) }
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="calendar_btn_wrap">
                                        <input type="button" name="" value="Generate" onClick={ this.getResourceDetails } className="common_cta_btn blue" />
                                    </div>
                                </div>
                                <div className="bill_table_wrap clearfix bill_instance_table" id="instanceTable">
                                    <div className="plan_scpu" style={ { display: "block" } }>
                                        <div className="plan_container">
                                            <ul className="scpu_tabs">

                                                <li data-tabs="SCPU-postpaidmonthly" className={ this.state.isPrepaidMonthly || this.state.isYearly ? "" : "active" } onClick={ () => this.callMonthlyResources() } >
                                                    <p className="text">Postpaid Monthly</p>
                                                </li>

                                                <li data-tabs="SCPU-monthly" className={ this.state.isPrepaidMonthly ? "active" : "" } onClick={ () => this.callPrepaidMonthlyResources() } >
                                                    <p className="text">Prepaid Monthly</p>
                                                </li>

                                                <li className={ this.state.isYearly ? "active" : "" } data-tabs="SCPU-yearly" onClick={ () => this.callYearResources() }>
                                                    <p className="text">Prepaid Yearly</p>
                                                </li>

                                            </ul>
                                            <div className={ this.state.isYearly ? "scpu_yearly_plan show" : "scpu_yearly_plan" }>
                                                <div className="tabular_data_wrap">
                                                    <div className="table_header">
                                                        <ul>
                                                            <li className="th">
                                                                <div className="col col1">Instances</div>
                                                                <div className="col col2">Billed On</div>
                                                                <div className="col col3">Amount Charged</div>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div className="table_data">
                                                        <ul>{ this.state.yearlyInstance.length === 0 ?
                                                            <li className="tr table_data_empty">
                                                                <div className="outer_empty_wrap">
                                                                    <div className="inner_empty_wrap">
                                                                        {/* <div className="svg_wrap empty_icon billing_instance_empty"></div> */ }
                                                                        <p className="empty_title">No instance details found</p>
                                                                    </div>
                                                                </div>
                                                            </li>
                                                            : this.state.yearlyPagedInstance.map(ins => (
                                                                <li className="tr" key={ ins.id }>
                                                                    <div className="col col1">
                                                                        <div className="server_icon">
                                                                            <div className="icon_img fedora">
                                                                                <span className="icon">
                                                                                    <svg x="0px" y="0px" viewBox="0 0 30 30" enableBackground="new 0 0 30 30" xmlSpace="preserve">
                                                                                        <path fill="#FFFFFF" d="M8.2,19.5c0,1.3,1,2.3,2.3,2.3s2.3-1,2.3-2.3v-2.3h-2.3C9.2,17.2,8.2,18.2,8.2,19.5L8.2,19.5z"></path>
                                                                                        <path fill="#FFFFFF" d="M18,9.7c-1.3,0-2.3,1-2.3,2.3v2.3H18c1.3,0,2.3-1,2.3-2.3S19.3,9.7,18,9.7L18,9.7z"></path>
                                                                                        <path fill="#FFFFFF" d="M16.9,4.2c-5.1-1-10.6,2.3-12.3,7.5C3.8,14,4.1,16.3,4,18.6c0,7.9-0.5,7.4,7.5,7.4c1.3,0,2.5,0,3.7,0  c5.6-0.2,10.1-4.4,10.7-9.9C26.4,10.4,22.5,5.2,16.9,4.2z M18,16.7h-2.8v2.8c0,2.6-2.1,4.7-4.7,4.7c-2.6,0-4.7-2.1-4.7-4.7  c0-2.6,2.1-4.7,4.7-4.7l0,0h2.8V12c0-2.6,2.1-4.7,4.7-4.7c2.6,0,4.7,2.1,4.7,4.7C22.7,14.6,20.6,16.7,18,16.7z"></path>
                                                                                    </svg>
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                        <div className="server_content">
                                                                            <div className="sys_os" ><span data-tip={ ins.name }>{ ins.name }</span></div>
                                                                            <ReactTooltip effect="solid" place="top"></ReactTooltip>
                                                                            <div className="sys_config"><span data-tip={ ins.sysConfig }>{ ins.sysConfig }</span>
                                                                                <ReactTooltip effect="solid" place="top"></ReactTooltip>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col col2">{ ins.created == null ? "" : ins.created }</div>
                                                                    <div className="col col3">{ Number(ins.price).toFixed(2) } USD</div>
                                                                </li>
                                                            )) }
                                                            <li className="tr total pagination_wrp">
                                                                <div className="col col1">Total charges for instance: <span className="highlight">{ Math.round((Number(this.state.totalYearlyPrice) + Number.EPSILON) * 100) / 100 } USD</span></div>
                                                                <div className="pagination_inner__box" style={ { display: this.state.yearlyInstance.length > this.state.count ? '' : 'none' } }>
                                                                    <div className="Page_navigation">
                                                                        <ul className="pagination_ul">
                                                                            <li className={ this.state.indexCount === 0 ? "page-item disabled" : "page-item" }>
                                                                                <a className="page-link hover-btn" aria-label="Previous" data-toggle="tooltip" data-tip data-for="prev-page" data-placement="top" data-original-title="Previous" onClick={ (event) => { this.handlePreviousClick(event); } }>
                                                                                    <ReactTooltip id="prev-page" place="top" effect="solid">Previous</ReactTooltip>
                                                                                    <span aria-hidden="true">«</span>
                                                                                    <span className="sr-only">Previous</span>
                                                                                </a>
                                                                            </li>
                                                                            <li className="page-item ">
                                                                                <a className="page-link " data-toggle="tooltip" data-placement="top" title="" data-original-title="0-50">
                                                                                    { this.state.indexCount + 1 } - { (this.state.indexCount + this.state.count) > this.state.yearlyInstance.length ? this.state.yearlyInstance.length : (this.state.indexCount + this.state.count) }

                                                                                </a>
                                                                            </li>
                                                                            <li className={ this.state.indexCount + this.state.count > this.state.yearlyInstance.length - 1 ? "page-item disabled" : "page-item" }>
                                                                                <a className="page-link hover-btn" href="#" data-tip data-for="next-page" aria-label="Next" data-toggle="tooltip" data-placement="top" data-original-title="Next" onClick={ (e) => { this.handleNextClick(e); } }>
                                                                                    <ReactTooltip id="next-page" place="top" effect="solid">Next</ReactTooltip>
                                                                                    <span aria-hidden="true">»</span>
                                                                                    <span className="sr-only">Next</span>
                                                                                </a>
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                </div>

                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <p className="form_note"><b>Note - </b>The pricing offer is subject to current promotion and it may change in the future.</p>
                                                    <p className="form_note">The deleted yearly and monthly plans will not be displayed under billing history.</p>

                                                </div>
                                            </div>
                                            <div className={ this.state.isPrepaidMonthly ? "scpu_monthly_plan show" : "scpu_monthly_plan" }>
                                                <div className="tabular_data_wrap">
                                                    <div className="table_header">
                                                        <ul>
                                                            <li className="th">
                                                                <div className="col col1">Instances</div>
                                                                <div className="col col2">Billed On</div>
                                                                <div className="col col3">Amount Charged</div>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div className="table_data">
                                                        <ul>{ this.state.prepaidMonthlyInsatnces.length === 0 ?
                                                            <li className="tr table_data_empty">
                                                                <div className="outer_empty_wrap">
                                                                    <div className="inner_empty_wrap">
                                                                        {/* <div className="svg_wrap empty_icon billing_instance_empty"></div> */ }
                                                                        <p className="empty_title">No instance details found</p>
                                                                    </div>
                                                                </div>
                                                            </li>
                                                            : this.state.prepaidMonthlyPaged.map(ins => (
                                                                <li className="tr" key={ ins.id }>
                                                                    <div className="col col1">
                                                                        <div className="server_icon">
                                                                            <div className="icon_img fedora">
                                                                                <span className="icon">
                                                                                    <svg x="0px" y="0px" viewBox="0 0 30 30" enableBackground="new 0 0 30 30" xmlSpace="preserve">
                                                                                        <path fill="#FFFFFF" d="M8.2,19.5c0,1.3,1,2.3,2.3,2.3s2.3-1,2.3-2.3v-2.3h-2.3C9.2,17.2,8.2,18.2,8.2,19.5L8.2,19.5z"></path>
                                                                                        <path fill="#FFFFFF" d="M18,9.7c-1.3,0-2.3,1-2.3,2.3v2.3H18c1.3,0,2.3-1,2.3-2.3S19.3,9.7,18,9.7L18,9.7z"></path>
                                                                                        <path fill="#FFFFFF" d="M16.9,4.2c-5.1-1-10.6,2.3-12.3,7.5C3.8,14,4.1,16.3,4,18.6c0,7.9-0.5,7.4,7.5,7.4c1.3,0,2.5,0,3.7,0  c5.6-0.2,10.1-4.4,10.7-9.9C26.4,10.4,22.5,5.2,16.9,4.2z M18,16.7h-2.8v2.8c0,2.6-2.1,4.7-4.7,4.7c-2.6,0-4.7-2.1-4.7-4.7  c0-2.6,2.1-4.7,4.7-4.7l0,0h2.8V12c0-2.6,2.1-4.7,4.7-4.7c2.6,0,4.7,2.1,4.7,4.7C22.7,14.6,20.6,16.7,18,16.7z"></path>
                                                                                    </svg>
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                        <div className="server_content">
                                                                            <div className="sys_os" ><span data-tip={ ins.name }>{ ins.name }</span></div>
                                                                            <ReactTooltip effect="solid" place="top"></ReactTooltip>
                                                                            <div className="sys_config"><span data-tip={ ins.sysConfig }>{ ins.sysConfig }</span>
                                                                                <ReactTooltip effect="solid" place="top"></ReactTooltip>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col col2">{ ins.created == null ? "" : ins.created }</div>
                                                                    <div className="col col3">{ Number(ins.price).toFixed(2) } USD</div>
                                                                </li>
                                                            )) }
                                                            <li className="tr total pagination_wrp">
                                                                <div className="col col1">Total charges for instance: <span className="highlight">{ Math.round((Number(this.state.totalMonthlyPrice) + Number.EPSILON) * 100) / 100 } USD</span></div>
                                                                <div className="pagination_inner__box" style={ { display: this.state.prepaidMonthlyInsatnces.length > this.state.count ? '' : 'none' } }>
                                                                    <div className="Page_navigation">
                                                                        <ul className="pagination_ul">
                                                                            <li className={ this.state.prepaidMonthIndex === 0 ? "page-item disabled" : "page-item" }>
                                                                                <a className="page-link hover-btn" aria-label="Previous" data-toggle="tooltip" data-tip data-for="prev-page" data-placement="top" data-original-title="Previous" onClick={ (event) => { this.handlePreviousClick(event); } }>
                                                                                    <ReactTooltip id="prev-page" place="top" effect="solid">Previous</ReactTooltip>
                                                                                    <span aria-hidden="true">«</span>
                                                                                    <span className="sr-only">Previous</span>
                                                                                </a>
                                                                            </li>
                                                                            <li className="page-item ">
                                                                                <a className="page-link " data-toggle="tooltip" data-placement="top" title="" data-original-title="0-50">
                                                                                    { this.state.prepaidMonthIndex + 1 } - { (this.state.prepaidMonthIndex + this.state.count) > this.state.prepaidMonthlyInsatnces.length ? this.state.prepaidMonthlyInsatnces.length : (this.state.prepaidMonthIndex + this.state.count) }

                                                                                </a>
                                                                            </li>
                                                                            <li className={ this.state.prepaidMonthIndex + this.state.count > this.state.prepaidMonthlyInsatnces.length - 1 ? "page-item disabled" : "page-item" }>
                                                                                <a className="page-link hover-btn" href="#" data-tip data-for="next-page" aria-label="Next" data-toggle="tooltip" data-placement="top" data-original-title="Next" onClick={ (e) => { this.handleNextClick(e); } }>
                                                                                    <ReactTooltip id="next-page" place="top" effect="solid">Next</ReactTooltip>
                                                                                    <span aria-hidden="true">»</span>
                                                                                    <span className="sr-only">Next</span>
                                                                                </a>
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                </div>

                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <p className="form_note"><b>Note - </b>The pricing offer is subject to current promotion and it may change in the future.</p>
                                                    <p className="form_note">The deleted yearly and monthly plans will not be displayed under billing history.</p>

                                                </div>
                                            </div>
                                            <div className={ this.state.isYearly || this.state.isPrepaidMonthly ? "scpu_postpaidmonthly_plan" : "scpu_postpaidmonthly_plan show" }>
                                                <div className="tabular_data_wrap">
                                                    <div className="table_header">
                                                        <ul>
                                                            <li className="th">
                                                                <div className="col col1">Instances</div>
                                                                <div className="col col2">Duration</div>
                                                                <div className="col col3">Amount</div>

                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div className="table_data">
                                                        <ul>{ this.state.monthlyInstances.length === 0 ?
                                                            <li className="tr table_data_empty">
                                                                <div className="outer_empty_wrap">
                                                                    <div className="inner_empty_wrap">
                                                                        {/* <div className="svg_wrap empty_icon billing_instance_empty"></div> */ }
                                                                        <p className="empty_title">No instance details found</p>
                                                                    </div>
                                                                </div>
                                                            </li>
                                                            : this.state.monthlyInstances.map(ins => (
                                                                <li className="tr" key={ ins.id }>
                                                                    <div className="col col1">
                                                                        <div className="server_icon">
                                                                            <div className="icon_img fedora">
                                                                                <span className="icon">
                                                                                    <svg x="0px" y="0px" viewBox="0 0 30 30" enableBackground="new 0 0 30 30" xmlSpace="preserve">
                                                                                        <path fill="#FFFFFF" d="M8.2,19.5c0,1.3,1,2.3,2.3,2.3s2.3-1,2.3-2.3v-2.3h-2.3C9.2,17.2,8.2,18.2,8.2,19.5L8.2,19.5z"></path>
                                                                                        <path fill="#FFFFFF" d="M18,9.7c-1.3,0-2.3,1-2.3,2.3v2.3H18c1.3,0,2.3-1,2.3-2.3S19.3,9.7,18,9.7L18,9.7z"></path>
                                                                                        <path fill="#FFFFFF" d="M16.9,4.2c-5.1-1-10.6,2.3-12.3,7.5C3.8,14,4.1,16.3,4,18.6c0,7.9-0.5,7.4,7.5,7.4c1.3,0,2.5,0,3.7,0  c5.6-0.2,10.1-4.4,10.7-9.9C26.4,10.4,22.5,5.2,16.9,4.2z M18,16.7h-2.8v2.8c0,2.6-2.1,4.7-4.7,4.7c-2.6,0-4.7-2.1-4.7-4.7  c0-2.6,2.1-4.7,4.7-4.7l0,0h2.8V12c0-2.6,2.1-4.7,4.7-4.7c2.6,0,4.7,2.1,4.7,4.7C22.7,14.6,20.6,16.7,18,16.7z"></path>
                                                                                    </svg>
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                        <div className="server_content">
                                                                            <div className="sys_os"><span data-tip={ ins.name }>{ ins.name }</span></div>
                                                                            <ReactTooltip effect="solid" place="top"></ReactTooltip>
                                                                            <div className="sys_config"><span data-tip={ ins.flavour }>{ ins.flavour }</span>
                                                                                <ReactTooltip effect="solid" place="top"></ReactTooltip>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col col2">{ ins.duration == null ? "" : ins.duration }</div>
                                                                    <div className="col col3">{ ins.amount } USD</div>
                                                                </li>
                                                            )) }
                                                            <li className="tr total pagination_wrp">
                                                                <div className="col col1">Total charges for instance: <span className="highlight">{ Math.round((Number(this.state.instanceTotal) + Number.EPSILON) * 100) / 100 } USD</span></div>
                                                                <div className="pagination_inner__box" style={ { display: this.state.instanceList.length > this.state.count ? '' : 'none' } }>
                                                                    <div className="Page_navigation">
                                                                        <ul className="pagination_ul">
                                                                            <li className={ this.state.monIndexCount === 0 ? "page-item disabled" : "page-item" }>
                                                                                <a className="page-link hover-btn" data-tip data-for="prev-page1" data-toggle="tooltip" data-placement="top" data-original-title="Previous" onClick={ (event) => { this.handlePreviousInstClick(event); } }>
                                                                                    <ReactTooltip id="prev-page1" place="top" effect="solid">Previous</ReactTooltip>
                                                                                    <span aria-hidden="true">«</span>
                                                                                    <span className="sr-only">Previous</span>
                                                                                </a>
                                                                            </li>
                                                                            <li className="page-item ">
                                                                                <a className="page-link " data-toggle="tooltip" data-placement="top" title="" data-original-title="0-50">
                                                                                    { this.state.monIndexCount + 1 } - { (this.state.monIndexCount + this.state.count) > this.state.instanceList.length ? this.state.instanceList.length : (this.state.monIndexCount + this.state.count) }

                                                                                </a>
                                                                            </li>
                                                                            <li className={ this.state.monIndexCount + this.state.count > this.state.instanceList.length - 1 ? "page-item disabled" : "page-item" }>
                                                                                <a className="page-link hover-btn" data-tip data-for="next-page1" href="#" aria-label="Next" data-toggle="tooltip" data-placement="top" title="" data-original-title="Next" onClick={ (e) => { this.handleNextInstClick(e); } }>
                                                                                    <ReactTooltip id="next-page1" place="top" effect="solid">Next</ReactTooltip>
                                                                                    <span aria-hidden="true">»</span>
                                                                                    <span className="sr-only">Next</span>
                                                                                </a>
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                </div>

                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="bill_table_wrap clearfix bill_image_table" id="imageTable">
                                    <div className="tabular_data_wrap">
                                        <div className="table_header">
                                            <ul>
                                                <li className="th">
                                                    <div className="col col1">Images</div>
                                                    <div className="col col2">Duration</div>
                                                    <div className="col col3">Amount</div>
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="table_data">
                                            <ul>{ this.state.pagedImageList.length === 0 ?
                                                <li className="tr table_data_empty">
                                                    <div className="outer_empty_wrap">
                                                        <div className="inner_empty_wrap">
                                                            {/* <div className="svg_wrap empty_icon  billing_images_empty"></div> */ }
                                                            <p className="empty_title">No image details found</p>
                                                        </div>
                                                    </div>
                                                </li>
                                                : this.state.pagedImageList.map(image => (
                                                    <li className="tr" key={ image.id }>
                                                        <div className="col col1">
                                                            <div className="server_icon">
                                                                <div className="icon_img fedora">
                                                                    <span className="icon">
                                                                        <svg x="0px" y="0px" viewBox="0 0 30 30" enableBackground="new 0 0 30 30" xmlSpace="preserve">
                                                                            <path fill="#FFFFFF" d="M8.2,19.5c0,1.3,1,2.3,2.3,2.3s2.3-1,2.3-2.3v-2.3h-2.3C9.2,17.2,8.2,18.2,8.2,19.5L8.2,19.5z"></path>
                                                                            <path fill="#FFFFFF" d="M18,9.7c-1.3,0-2.3,1-2.3,2.3v2.3H18c1.3,0,2.3-1,2.3-2.3S19.3,9.7,18,9.7L18,9.7z"></path>
                                                                            <path fill="#FFFFFF" d="M16.9,4.2c-5.1-1-10.6,2.3-12.3,7.5C3.8,14,4.1,16.3,4,18.6c0,7.9-0.5,7.4,7.5,7.4c1.3,0,2.5,0,3.7,0  c5.6-0.2,10.1-4.4,10.7-9.9C26.4,10.4,22.5,5.2,16.9,4.2z M18,16.7h-2.8v2.8c0,2.6-2.1,4.7-4.7,4.7c-2.6,0-4.7-2.1-4.7-4.7  c0-2.6,2.1-4.7,4.7-4.7l0,0h2.8V12c0-2.6,2.1-4.7,4.7-4.7c2.6,0,4.7,2.1,4.7,4.7C22.7,14.6,20.6,16.7,18,16.7z"></path>
                                                                        </svg>
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <div className="server_content">
                                                                <div className="sys_os" title={ image.name }>{ image.name }</div>
                                                                <div className="sys_config">{ image.flavour }</div>
                                                            </div>
                                                        </div>
                                                        <div className="col col2">{ image.duration }</div>
                                                        <div className="col col3">{ image.amount } USD</div>
                                                    </li>
                                                )) }
                                                <li className="tr total pagination_wrp">
                                                    <div className="col col1">Total charges for image: <span className="highlight">{ Math.round((Number(this.state.imageTotal) + Number.EPSILON) * 100) / 100 } USD</span></div>
                                                    <div className="pagination_inner__box" style={ { display: this.state.imageList.length > this.state.count ? '' : 'none' } }>
                                                        <div className="Page_navigation">
                                                            <ul className="pagination_ul">
                                                                <li className={ this.state.imageIndexCount === 0 ? "page-item disabled" : "page-item" }>
                                                                    <a className="page-link hover-btn" data-tip data-for="prev-page2" data-toggle="tooltip" data-placement="top" title="" data-original-title="Previous" onClick={ (event) => { this.handlePreviousImagesClick(event); } }>
                                                                        <ReactTooltip id="prev-page2" place="top" effect="solid">Previous</ReactTooltip>
                                                                        <span aria-hidden="true">«</span>
                                                                        <span className="sr-only">Previous</span>
                                                                    </a>
                                                                </li>
                                                                <li className="page-item ">
                                                                    <a className="page-link " data-toggle="tooltip" data-placement="top" title="" data-original-title="0-50">
                                                                        { this.state.imageIndexCount + 1 } - { (this.state.imageIndexCount + this.state.count) > this.state.imageList.length ? this.state.imageList.length : (this.state.imageIndexCount + this.state.count) }

                                                                    </a>
                                                                </li>
                                                                <li className={ this.state.imageIndexCount + this.state.count > this.state.imageList.length - 1 ? "page-item disabled" : "page-item" }>
                                                                    <a className="page-link hover-btn" data-tip data-for="next-page2" href="#" aria-label="Next" data-toggle="tooltip" data-placement="top" title="" data-original-title="Next" onClick={ (e) => { this.handleNextImagesClick(e); } }>
                                                                        <ReactTooltip id="next-page2" place="top" effect="solid">Next</ReactTooltip>
                                                                        <span aria-hidden="true">»</span>
                                                                        <span className="sr-only">Next</span>
                                                                    </a>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>

                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="bill_table_wrap clearfix bill_volume_table volumePrepaid" id="volumeTable">
                                    <div className="plan_scpu" style={ { display: "block" } }>
                                        <div className="plan_container">
                                            <ul className="scpu_tabs">
                                                <li data-tabs="vol-monthly" className={ this.state.isYearlyVol ? "" : "active" }
                                                    onClick={ () => this.calVolumeOperation("monthly") }>
                                                    <p className="text">Monthly</p>
                                                </li>
                                                <li data-tabs="vol-yearly" className={ this.state.isYearlyVol ? "active" : "" }
                                                    onClick={ () => this.calVolumeOperation("yearly") }>
                                                    <p className="text">Yearly</p>
                                                </li>
                                            </ul>
                                            <div className={ this.state.isYearlyVol ? "scpu_yearly_plan show" : "scpu_yearly_plan" }>
                                                <div className="tabular_data_wrap">
                                                    <div className="table_header">
                                                        <ul>
                                                            <li className="th">
                                                                <div className="col col1">Volumes</div>
                                                                <div className="col col2">Size (GB)</div>
                                                                <div className="col col3">Billed On</div>
                                                                <div className="col col4">Amount Charged</div>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div className="table_data">
                                                        <ul>{ this.state.yearlyVolumes.length === 0 ?
                                                            <li className="tr table_data_empty">
                                                                <div className="outer_empty_wrap">
                                                                    <div className="inner_empty_wrap">
                                                                        {/* <div className="svg_wrap empty_icon  billing_volumes_empty"></div> */ }
                                                                        <p className="empty_title">No volumes details found</p>
                                                                    </div>
                                                                </div>
                                                            </li>
                                                            : this.state.yearlyPagedVolumes.map(volume => (
                                                                <li className="tr" key={ volume.volId }>
                                                                    <div className="col col1">
                                                                        <div className="server_icon">
                                                                            <div className="icon_img">
                                                                                <span className="icon">
                                                                                    <svg x="0px" y="0px" width="30px" height="24.3px" viewBox="0 0 30 24.3" enableBackground="new 0 0 30 24.3" xmlSpace="preserve">
                                                                                        <path fillRule="evenodd" clipRule="evenodd" fill="#59A7DA" d="M29,12.7v8c0,1.1-0.9,2-2,2H3c-1.1,0-2-0.9-2-2v-8  c0-0.2,0-0.8,0-1.4c0-0.1,0-0.6,0.2-1L4,3.7c0.7-1.3,1.4-1.9,3-2h16c1.7-0.1,2,0.6,2.9,1.9l2.9,6.8C29.1,10.9,29,12.7,29,12.7z   M3,19.7c0,0.6,0.4,1,1,1h22c0.6,0,1-0.4,1-1v-6c0-0.6-0.4-1-1-1H4c-0.6,0-1,0.4-1,1V19.7z M26,9.7l-2-5c-0.2-0.5-0.4-1-1-1H7  c-0.6,0-0.8,0.5-1,1l-2,5c-0.2,0.3-0.3,0.9,0,1h22C26.4,10.7,26.2,10,26,9.7z M6,15.7h12c0.6,0,1,0.4,1,1s-0.4,1-1,1H6  c-0.6,0-1-0.4-1-1S5.4,15.7,6,15.7z M24,15.7c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1S23.4,15.7,24,15.7z"></path>
                                                                                    </svg>
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                        <div className="server_content">
                                                                            <div className="vol_name" title={ volume.name }>{ volume.name }</div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col col2">{ volume.size }</div>
                                                                    <div className="col col3">{ volume.created }</div>
                                                                    <div className="col col4">{ volume.price } USD</div>
                                                                </li>
                                                            )) }
                                                            <li className="tr total pagination_wrp">
                                                                <div className="col col1">Total charges for volume: <span className="highlight">{ Math.round((Number(this.state.totalVolumesPrice) + Number.EPSILON) * 100) / 100 } USD</span></div>
                                                                <div className="pagination_inner__box" style={ { display: this.state.yearlyVolumes.length > this.state.count ? '' : 'none' } }>
                                                                    <div className="Page_navigation">
                                                                        <ul className="pagination_ul">
                                                                            <li className={ this.state.yearlyVolIndexCount === 0 ? "page-item disabled" : "page-item" }>
                                                                                <a className="page-link hover-btn" data-tip data-for="prev-page3" data-toggle="tooltip" data-placement="top" title="" data-original-title="Previous" onClick={ (event) => { this.handlePreviousYearlyVolClick(event); } }>
                                                                                    <ReactTooltip id="prev-page3" place="top" effect="solid">Previous</ReactTooltip>
                                                                                    <span aria-hidden="true">«</span>
                                                                                    <span className="sr-only">Previous</span>
                                                                                </a>
                                                                            </li>
                                                                            <li className="page-item ">
                                                                                <a className="page-link " data-toggle="tooltip" data-placement="top" title="" data-original-title="0-50">
                                                                                    { this.state.yearlyVolIndexCount + 1 } - { (this.state.yearlyVolIndexCount + this.state.count) > this.state.yearlyVolumes.length ? this.state.yearlyVolumes.length : (this.state.yearlyVolIndexCount + this.state.count) }

                                                                                </a>
                                                                            </li>
                                                                            <li className={ this.state.yearlyVolIndexCount + this.state.count > this.state.yearlyVolumes.length - 1 ? "page-item disabled" : "page-item" }>
                                                                                <a className="page-link hover-btn" href="#" aria-label="Next" data-tip data-for="next-page3" data-toggle="tooltip" data-placement="top" title="" data-original-title="Next" onClick={ (e) => { this.handleNextYearlyVolClick(e); } }>
                                                                                    <ReactTooltip id="next-page3" place="top" effect="solid">Next</ReactTooltip>
                                                                                    <span aria-hidden="true">»</span>
                                                                                    <span className="sr-only">Next</span>
                                                                                </a>
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                </div>

                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <p className="empty_title">Note - The pricing discount is subject to current promotion and it may change in the future.</p>
                                                    <p className="empty_title">The deleted yearly volumes will not be displayed under billing history.</p>
                                                </div>
                                            </div>
                                            <div className={ this.state.isYearlyVol ? "scpu_monthly_plan" : "scpu_monthly_plan show" }>
                                                <div className="tabular_data_wrap">
                                                    <div className="table_header">
                                                        <ul>
                                                            <li className="th">
                                                                <div className="col col1">Volumes</div>
                                                                <div className="col col2">Duration</div>
                                                                <div className="col col3">Amount</div>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div className="table_data">
                                                        <ul>{ this.state.pagedVolumeList.length === 0 ?
                                                            <li className="tr table_data_empty">
                                                                <div className="outer_empty_wrap">
                                                                    <div className="inner_empty_wrap">
                                                                        {/* <div className="svg_wrap empty_icon  billing_volumes_empty"></div> */ }
                                                                        <p className="empty_title">No volumes details found</p>
                                                                    </div>
                                                                </div>
                                                            </li>
                                                            : this.state.pagedVolumeList.map(volume => (
                                                                <li className="tr" key={ volume.id }>
                                                                    <div className="col col1">
                                                                        <div className="server_icon">
                                                                            <div className="icon_img">
                                                                                <span className="icon">
                                                                                    <svg x="0px" y="0px" width="30px" height="24.3px" viewBox="0 0 30 24.3" enableBackground="new 0 0 30 24.3" xmlSpace="preserve">
                                                                                        <path fillRule="evenodd" clipRule="evenodd" fill="#59A7DA" d="M29,12.7v8c0,1.1-0.9,2-2,2H3c-1.1,0-2-0.9-2-2v-8  c0-0.2,0-0.8,0-1.4c0-0.1,0-0.6,0.2-1L4,3.7c0.7-1.3,1.4-1.9,3-2h16c1.7-0.1,2,0.6,2.9,1.9l2.9,6.8C29.1,10.9,29,12.7,29,12.7z   M3,19.7c0,0.6,0.4,1,1,1h22c0.6,0,1-0.4,1-1v-6c0-0.6-0.4-1-1-1H4c-0.6,0-1,0.4-1,1V19.7z M26,9.7l-2-5c-0.2-0.5-0.4-1-1-1H7  c-0.6,0-0.8,0.5-1,1l-2,5c-0.2,0.3-0.3,0.9,0,1h22C26.4,10.7,26.2,10,26,9.7z M6,15.7h12c0.6,0,1,0.4,1,1s-0.4,1-1,1H6  c-0.6,0-1-0.4-1-1S5.4,15.7,6,15.7z M24,15.7c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1S23.4,15.7,24,15.7z"></path>
                                                                                    </svg>
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                        <div className="server_content">
                                                                            <div className="vol_name" title={ volume.name }>{ volume.name }</div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col col2">{ volume.duration }</div>
                                                                    <div className="col col3">{ volume.amount } USD</div>
                                                                </li>
                                                            )) }
                                                            <li className="tr total pagination_wrp">
                                                                <div className="col col1">Total charges for volume: <span className="highlight">{ Math.round((Number(this.state.volumeTotal) + Number.EPSILON) * 100) / 100 } USD</span></div>
                                                                <div className="pagination_inner__box" style={ { display: this.state.volumeList.length > this.state.count ? '' : 'none' } }>
                                                                    <div className="Page_navigation">
                                                                        <ul className="pagination_ul">
                                                                            <li className={ this.state.volIndexCount === 0 ? "page-item disabled" : "page-item" }>
                                                                                <a className="page-link hover-btn" data-tip data-for="prev-page3" data-toggle="tooltip" data-placement="top" title="" data-original-title="Previous" onClick={ (event) => { this.handlePreviousVolumeClick(event); } }>
                                                                                    <ReactTooltip id="prev-page3" place="top" effect="solid">Previous</ReactTooltip>
                                                                                    <span aria-hidden="true">«</span>
                                                                                    <span className="sr-only">Previous</span>
                                                                                </a>
                                                                            </li>
                                                                            <li className="page-item ">
                                                                                <a className="page-link " data-toggle="tooltip" data-placement="top" title="" data-original-title="0-50">
                                                                                    { this.state.volIndexCount + 1 } - { (this.state.volIndexCount + this.state.count) > this.state.volumeList.length ? this.state.volumeList.length : (this.state.volIndexCount + this.state.count) }

                                                                                </a>
                                                                            </li>
                                                                            <li className={ this.state.volIndexCount + this.state.count > this.state.volumeList.length - 1 ? "page-item disabled" : "page-item" }>
                                                                                <a className="page-link hover-btn" href="#" aria-label="Next" data-tip data-for="next-page3" data-toggle="tooltip" data-placement="top" title="" data-original-title="Next" onClick={ (e) => { this.handleNextVolumeClick(e); } }>
                                                                                    <ReactTooltip id="next-page3" place="top" effect="solid">Next</ReactTooltip>
                                                                                    <span aria-hidden="true">»</span>
                                                                                    <span className="sr-only">Next</span>
                                                                                </a>
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                </div>

                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="bill_table_wrap clearfix bill_bandwidth_table bill_bandwidth_detail" id="bandwidthTable">
                                    { (this.state.isBandwidthResponseNull === 'true') || (this.state.monthYear !== this.state.currMonthYear) || this.state.ccDetails === false ? '' :
                                        <div className="bandwidth_progress">
                                            <div className="boot_container">
                                                <div className="boot_wrapper">
                                                    <div className="progress_wrap">
                                                        <span className="progress_limit">{ this.state.usedBandwidth } of { this.state.allocatedBandwidth } used</span>
                                                        <span className="progress_val">{ customBandwidthPercent }</span>
                                                        <div className="progress_bar">
                                                            <span className={ fullClassForBandwidthColor } style={ { width: customBandwidthPercent } }></span>
                                                        </div>
                                                    </div>
                                                    <span className="svg_wrap" data-tip data-for="showPerc">
                                                        <svg x="0px" y="0px" viewBox="0 0 22 20" enable-background="new 0 0 22 20" xmlSpace="preserve">
                                                            <path fill-rule="evenodd" clip-rule="evenodd" fill="#669ebe" d="M11,1c5,0,9,4,9,9s-4,9-9,9c-5,0-9-4-9-9S6,1,11,1z"></path>
                                                            <text transform="matrix(1 0 0 1 9.0724 15.4681)" fill="#FFFFFF" fontFamily="'Roboto-Medium'" fontSize="14px">i</text>
                                                        </svg>
                                                    </span>
                                                    <ReactTooltip id="showPerc" effect="solid" place="top">Your account's monthly<br></br> network transfer allotment<br></br> will reset in { this.state.bandwidthResetDays } day(s).</ReactTooltip>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    <div className="tabular_data_wrap">
                                        <div className="table_header">
                                            <ul>
                                                <li className="th">
                                                    <div className="col col1">Bandwidth Usage</div>
                                                    <div className="col col3">Amount</div>

                                                </li>
                                            </ul>
                                        </div>
                                        <div className="table_data">
                                            <ul>
                                                { this.state.bandwidthList.length === 0 ?
                                                    <li className="tr table_data_empty">
                                                        <div className="outer_empty_wrap">
                                                            <div className="inner_empty_wrap">
                                                                {/* <div className="svg_wrap empty_icon  billing_bandwidth_empty"></div> */ }
                                                                <p className="empty_title">You are within your allocated bandwidth limit</p>
                                                            </div>
                                                        </div>
                                                    </li>
                                                    : this.state.bandwidthList.map(bw => (
                                                        <li className="tr" key={ bw.id }>
                                                            <div className="col col1">
                                                                <div className="server_icon">
                                                                    <div className="icon_img">
                                                                        <span className="icon">
                                                                            <svg viewBox="0 0 20 20" enableBackground="new 0 0 20 20" xmlSpace="preserve">
                                                                                <path fillRule="evenodd" clipRule="evenodd" fill="#FFFFFF" d="M17.2,16h-1.7c0.8-1.1,1.2-2.4,1.2-3.9c0-0.9-0.2-1.7-0.5-2.5  l1.1-1c0.5,1.1,0.8,2.2,0.8,3.5C18.1,13.5,17.8,14.9,17.2,16z M11.6,11.3c0.1,0.2,0.2,0.5,0.2,0.8c0,1-0.8,1.8-1.8,1.8  s-1.8-0.8-1.8-1.8S9,10.4,10,10.4c0.2,0,0.3,0,0.5,0.1l5-4.8c0.3-0.3,0.7-0.3,1,0c0.3,0.3,0.3,0.7,0,1L11.6,11.3z M10,5.4  c-3.7,0-6.7,3-6.7,6.7c0,1.5,0.5,2.8,1.2,3.9H2.8c-0.6-1.2-1-2.5-1-3.9C1.9,7.6,5.5,4,10,4c1.4,0,2.8,0.4,3.9,1l-1.2,1  C11.9,5.6,11,5.4,10,5.4z" />
                                                                            </svg>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <div className="server_content">
                                                                    <div className="bandwidth_name">{ this.state.monthname }</div>
                                                                </div>
                                                            </div>
                                                            <div className="col col3">{ bw.amount } USD</div>
                                                        </li>
                                                    )) }


                                                <li className="tr total">
                                                    <div className="col col1">Total charges for bandwidth usage: <span className="highlight">{ Math.round((Number(this.state.bandwidthTotal) + Number.EPSILON) * 100) / 100 } USD</span></div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div >
                                <div className="bill_table_wrap clearfix bill_floatingIP_table" id="ipTable">

                                    <div className="tabular_data_wrap">
                                        <div className="table_header">

                                            <ul>
                                                <li className="th">
                                                    <div className="col col1">IP Address</div>
                                                    <div className="col col2">Duration</div>
                                                    <div className="col col3">Amount</div>
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="table_data">
                                            <ul>
                                                { this.state.pagedIpList.length == 0 ?
                                                    <li className="tr table_data_empty">
                                                        <div className="outer_empty_wrap">
                                                            <div className="inner_empty_wrap">
                                                                {/* <div className="svg_wrap empty_icon  billing_bandwidth_empty"></div> */ }
                                                                <p className="empty_title">No additional IP details found</p>
                                                            </div>
                                                        </div>
                                                    </li>
                                                    :
                                                    this.state.pagedIpList.map(ip =>
                                                        <li className="tr">
                                                            <div className="col col1">
                                                                <div className="ip_det">
                                                                    <span className="ip_addr">{ ip.id }</span>
                                                                    <span className="instance_name" data-tip data-for={ ip.id + ip.name }>{ ip.name }</span>
                                                                    <ReactTooltip id={ ip.id + ip.name } place="top" effect='solid'>{ ip.name }</ReactTooltip>
                                                                </div>
                                                            </div>
                                                            <div className="col col2">{ ip.duration }</div>
                                                            <div className="col col3">{ ip.amount } USD</div>
                                                        </li>
                                                    )


                                                }

                                                <li className="tr total pagination_wrp">
                                                    <div className="col col1">Total charges for additional IPs: <span className="highlight">{ Math.round((Number(this.state.totalIpAmount) + Number.EPSILON) * 100) / 100 } USD</span></div>
                                                    <div className="pagination_inner__box" style={ { display: this.state.ipFullList.length > this.state.count ? '' : 'none' } }>
                                                        <div className="Page_navigation">
                                                            <ul className="pagination_ul">
                                                                <li className={ this.state.ipIndexCount === 0 ? "page-item disabled" : "page-item" }>
                                                                    <a className="page-link hover-btn" data-tip data-for="prev-page4" data-toggle="tooltip" data-placement="top" title="" data-original-title="Previous" onClick={ (event) => { this.handlePreviousIpClick(event); } }>
                                                                        <ReactTooltip id="prev-page4" place="top" effect="solid">Previous</ReactTooltip>
                                                                        <span aria-hidden="true">«</span>
                                                                        <span className="sr-only">Previous</span>
                                                                    </a>
                                                                </li>
                                                                <li className="page-item ">
                                                                    <a className="page-link " data-toggle="tooltip" data-placement="top" title="" data-original-title="0-50">
                                                                        { this.state.ipIndexCount + 1 } - { (this.state.ipIndexCount + this.state.count) > this.state.ipFullList.length ? this.state.ipFullList.length : (this.state.ipIndexCount + this.state.count) }

                                                                    </a>
                                                                </li>
                                                                <li className={ this.state.ipIndexCount + this.state.count > this.state.ipFullList.length - 1 ? "page-item disabled" : "page-item" }>
                                                                    <a className="page-link hover-btn" href="#" data-tip data-for="next-page4" data-toggle="tooltip" data-placement="top" title="" data-original-title="Next" onClick={ (e) => { this.handleNextIpClick(e); } }>
                                                                        <ReactTooltip id="next-page4" place="top" effect="solid">Next</ReactTooltip>
                                                                        <span aria-hidden="true">»</span>
                                                                        <span className="sr-only">Next</span>
                                                                    </a>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>

                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="bill_table_wrap clearfix bill_lb_table" id="lbtable">
                                    <div className="tabular_data_wrap">
                                        <div className="table_header">
                                            <ul>
                                                <li className="th">
                                                    <div className="col col1">Load Balancers</div>
                                                    <div className="col col2">Duration</div>
                                                    <div className="col col3">Amount</div>
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="table_data">
                                            <ul>
                                                { this.state.pagedLbList.length == 0 ?
                                                    <li className="tr table_data_empty">
                                                        <div className="outer_empty_wrap">
                                                            <div className="inner_empty_wrap">
                                                                {/* <div className="svg_wrap empty_icon  billing_bandwidth_empty"></div> */ }
                                                                <p className="empty_title">No load balancer details found</p>
                                                            </div>
                                                        </div>
                                                    </li>
                                                    :
                                                    this.state.pagedLbList.map(lb =>
                                                        <li className="tr">
                                                            <div className="col col1">
                                                                <div className="name_icon">
                                                                    <span className="svg_wrap">
                                                                        <svg x="0px" y="0px" width="18px" height="18px" viewBox="0 0 18 18" xmlSpace="preserve">
                                                                            <g><rect x="3" y="3.5" className="lb_list1" width="12" height="3"></rect><rect x="1" y="11.4" className="lb_list1" width="4" height="3"></rect><rect x="7" y="11.4" className="lb_list1" width="4" height="3"></rect><rect x="13" y="11.4" className="lb_list1" width="4" height="3"></rect><path className="lb_list1" d="M3,11.4V9.7c0-0.2,0.1-0.3,0.3-0.3h11.4c0.2,0,0.3,0.1,0.3,0.3v1.7"></path><line className="lb_list1" x1="9" y1="11.6" x2="9" y2="6.7"></line></g>
                                                                        </svg>
                                                                    </span>
                                                                </div>
                                                                <span className="loadBalance_Name"> { lb.name }</span>

                                                            </div>
                                                            <div className="col col2">{ lb.duration }</div>
                                                            <div className="col col3">{ lb.amount } USD</div>
                                                        </li>
                                                    )


                                                }

                                                <li className="tr total">
                                                    <div className="col col1">Total charges for Load Balancers: <span className="highlight bill_total">{ Math.round((Number(this.state.totalLbAmount) + Number.EPSILON) * 100) / 100 } USD</span></div>
                                                    <div className="pagination_inner__box" style={ { display: this.state.lbFullList.length > this.state.count ? '' : 'none' } }>
                                                        <div className="Page_navigation">
                                                            <ul className="pagination_ul">
                                                                <li className={ this.state.lbIndexCount === 0 ? "page-item disabled" : "page-item" }>
                                                                    <a className="page-link hover-btn" data-tip data-for="prev-page4" data-toggle="tooltip" data-placement="top" title="" data-original-title="Previous" onClick={ (event) => { this.handlePreviousIpClick(event); } }>
                                                                        <ReactTooltip id="prev-page4" place="top" effect="solid">Previous</ReactTooltip>
                                                                        <span aria-hidden="true">«</span>
                                                                        <span className="sr-only">Previous</span>
                                                                    </a>
                                                                </li>
                                                                <li className="page-item ">
                                                                    <a className="page-link " data-toggle="tooltip" data-placement="top" title="" data-original-title="0-50">
                                                                        { this.state.lbIndexCount + 1 } - { (this.state.lbIndexCount + this.state.count) > this.state.lbFullList.length ? this.state.lbFullList.length : (this.state.lbIndexCount + this.state.count) }

                                                                    </a>
                                                                </li>
                                                                <li className={ this.state.lbIndexCount + this.state.count > this.state.lbFullList.length - 1 ? "page-item disabled" : "page-item" }>
                                                                    <a className="page-link hover-btn" href="#" data-tip data-for="next-page4" data-toggle="tooltip" data-placement="top" title="" data-original-title="Next" onClick={ (e) => { this.handleNextIpClick(e); } }>
                                                                        <ReactTooltip id="next-page4" place="top" effect="solid">Next</ReactTooltip>
                                                                        <span aria-hidden="true">»</span>
                                                                        <span className="sr-only">Next</span>
                                                                    </a>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div >
                            <div className="section_table_rhs">
                                <div className="unit_summary_rhs">
                                    <div className="rhs_block1">
                                        <div className="head_block">Billing Summary</div>
                                        <div className="summary_list">
                                            <ul>
                                                <li className="summary_instance_cost">
                                                    <h4>{ this.state.instanceTotal } USD</h4>
                                                    <div className="summary_info">Total instance cost</div>
                                                </li>
                                                <li className="summary_image_cost">
                                                    <h4>{ this.state.imageTotal } USD</h4>
                                                    <div className="summary_info">Total image cost</div>
                                                </li>
                                                <li className="summary_volume_cost">
                                                    <h4>{ this.state.volumeTotal } USD</h4>
                                                    <div className="summary_info">Total volume cost</div>
                                                </li>
                                                <li className="summary_bandwidth_cost">
                                                    <h4>{ this.state.bandwidthTotal } USD</h4>
                                                    <div className="summary_info">Total bandwidth usage cost</div>
                                                </li>
                                                <li className="bill_floatingIP_cost">
                                                    <h4>{ this.state.totalIpAmount } USD</h4>
                                                    <div className="summary_info">Total Additional IPs cost</div>
                                                </li>
                                                <li className="summary_lb_cost">
                                                    <h4>{ this.state.totalLbAmount } USD</h4>
                                                    <div className="summary_info">Total Load balancers cost</div>
                                                </li>
                                            </ul>
                                            <div className="total_amt_wrap">
                                                <span className="total_amt">${ this.state.totalCost }/month</span>
                                                <span className="summary_info">Total Cost</span>
                                            </div>
                                            {/* <div className="creditCardUpdate">
                                        <a href="accounts-creditCard_update.html">Update credit card</a>
                                    </div> */}
                                        </div>
                                    </div>
                                    <div className="rhs_block2">
                                        <div className="head_block" style={ { display: "none" } }>Billing Cycle Details</div>
                                        <div className="summary_list">
                                            <ul>
                                                <li className="summary_instance_cost">
                                                    <div className="summary_info">Next billing date:</div>
                                                    <h4>{ this.state.nextBillingDate }</h4>
                                                </li>
                                                {/* <li className="summary_image_cost">
                                            <div className="summary_info">Renewal Amount</div>
                                            <h4>11.47 USD</h4>
                                        </li> */}
                                            </ul>

                                        </div>
                                    </div>
                                    <p className="note"><b>Note:</b> For certain resources that have been renamed, you may continue to see their original names (names used during resource creation) in your Billing History. </p>
                                </div>
                            </div>
                        </div>
                    </div >
                    <CommonMessage message={ this.state.message } handler={ () => this.setState({ message: "" }) } />
                </section >
            </React.Fragment>
        );
    }
}

export default BillingHistory;
